module.exports = __webpack_public_path__ + "img/t_bg.602ae915.png";